import React, { useEffect, useState } from "react";
import logo from "../components/assets/logo.svg";
import cbn from "../components/assets/cbn.svg";
import icnaira from "../components/assets/ic-naira.svg";
import config from "../config.json";
import {
  getMerchantDetails,
  initiateThirdPartyInsuranceCard,
  initiateThirdPartyRideCard,
  initiateThirdPartyShopCard,
  listInsuranceCompany,
} from "../services/interface/InterfaceService";
import { Fire } from "../utils/Fire";
import { useLocation, useNavigate } from "react-router-dom";
import Success from "./Success";
import Decline from "./Decline";
import { formatAmount } from "../components/reusables/FormtMoney";
import {
  setTransactionReference,
  setTransactionToken,
} from "../utils/config";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
const PayWithCard = () => {
  // const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    amount: "",
    emailAddress: "",
    insuranceCompany: "",
  });
  const [error, setError] = useState({
    amount: false,
    emailAddress: false,
    insuranceCompany: false,
  });
  const query = useQuery();
  const [status, setStatus] = useState("none");
  const [insuranceData, setInsuranceData] = useState([]);
  const [showInsuranceCompany, setShowInsuranceCompany] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchMerchantAndInsuranceDetails = async () => {
      if (config.appName === "insurance") {
        try {
          // Fetch merchant details
          const merchantResponse = await getMerchantDetails();

          // If the merchant is an agent, fetch insurance companies
          if (merchantResponse?.isAgent) {
            const insuranceResponse = await listInsuranceCompany();
            setInsuranceData(insuranceResponse);
            setShowInsuranceCompany(true);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };

    fetchMerchantAndInsuranceDetails();
  }, [config.appName]);

  const validateForm = () => {
    let errors = {};

    if (!formData.amount) {
      errors.amount = "Amount is required.";
    } else if (
      isNaN(formData.amount.replace(/,/g, "")) ||
      parseFloat(formData.amount.replace(/,/g, "")) <= 0
    ) {
      errors.amount = "Amount must be a positive number.";
    }

    if (!formData.emailAddress) {
      errors.emailAddress = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.emailAddress)) {
      errors.emailAddress = "Email address is invalid.";
    }

    if (config.appName === "insurance" && showInsuranceCompany) {
      if (!formData.insuranceCompany || formData.insuranceCompany === "") {
        errors.insuranceCompany = "Choose an Insurance company.";
      }
    }

    return errors;
  };

  useEffect(() => {
    const refStatus = query.get("status");
    setStatus(refStatus);
  }, [query]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "amount") {
      let cleanedValue = value.replace(/[^0-9.]/g, "");
      const [integerPart, decimalPart] = cleanedValue.split(".");
      if (integerPart.length <= 9) {
        if (decimalPart) {
          if (decimalPart.length >= 3) {
            return null;
          }
        }
        const formattedValue = formatAmount(cleanedValue);
        setFormData({
          ...formData,
          [name]: formattedValue,
        });
        setError({
          ...error,
          amount: false,
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
      setError({
        ...error,
        emailAddress: false,
        insuranceCompany: false,
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length === 0) {
      // Proceed with payment logic
      handlePayNow();
    } else {
      setError(errors);
    }
  };


  const handlePayNow = async () => {
    try {
      const prefix = config.merchantPrefix;
      const reference = Math.random().toString(36).substring(5);
      const suffix = new Date().getTime();
      const fullRreference = `${prefix}${reference}${suffix}`;


      const request =
        config.appName === "insurance"
          ? {
              identifier: fullRreference,
              amount: formData.amount.replace(/,/g, ""),
              emailAddress: formData.emailAddress,
              redirectUrl: config.redirectUrl,
              insuranceCompany: formData.insuranceCompany,
            }
          : {
              identifier: fullRreference,
              amount: formData.amount.replace(/,/g, ""),
              emailAddress: formData.emailAddress,
              redirectUrl: config.redirectUrl,
            };


      setLoading(true);
      let response = {};

      if (config.appName === "shop") {
        response = await initiateThirdPartyShopCard(request);
        if (response) {
          setTransactionToken(response?.transactionToken)
          setTransactionReference(response?.transactionReference);
          window.open(response?.redirectionUrl, "_self");
        }
      } else if (config.appName === "ride") {
        response = await initiateThirdPartyRideCard(request);
        if (response) {
          setTransactionReference(response?.transactionReference);
          setTransactionReference(response?.transactionReference);
          setTransactionToken(response?.transactionToken)
          window.open(response?.redirectionUrl, "_self");
        }
      } else if (config.appName === "insurance") {
      
        const paymentResponse = await initiateThirdPartyInsuranceCard(request);
        if (paymentResponse) {
          //console.log("response Insurance", paymentResponse)
          setTransactionToken(paymentResponse?.transactionToken)
          setTransactionReference(paymentResponse?.transactionReference);
          localStorage.setItem("gatewayurl", paymentResponse?.redirectionUrl)
          navigate("/gateway/detail");
        }
        
      } else {
        Fire("error", "Invalid Configuration, Please contact support");
      }
    } catch (error) {
      Fire(
        "error",
        "Unable to process your request at the moment, Please try again later"
      );
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {status === "success" ? (
        <Success />
      ) : status === "failed" ? (
        <Decline />
      ) : (
        <div className="flex max-h-screen items-center justify-center bg-transparent bg-gray-600 mt-[unset] md:mt-5">
          <div className="rounded-lg bg-white md:w-[700px] w-full  border-[1px] border-gray-200 shadow-sm px-5 py-5 relative pb-10 mx-auto text-center">
            <div className="flex flex-col pt-5 items-center text-center justify-center md:w-[75%] w-full md:mx-auto md:my-auto md:px-10">
              <div className="self-center mb-7">
                <img src={logo} alt="logo" />
              </div>
              <div className=" flex md:w-[100%] w-full relative justify-center flex-row">
                <div>
                  <h2 className=" text-xl font-bold mb-5">
                    Pay securely with Card
                  </h2>
                </div>
              </div>

              <form
                onSubmit={handleSubmit}
                className="w-[90%]  px-3 rounded-md py-2 mt-5 flex flex-col items-center"
              >
                <div className="w-full">
                  <label
                    htmlFor="hs-leading-icon"
                    className="block text-left text-sm font-medium mb-1"
                  >
                    Amount
                  </label>
                  <div className="relative mb-5">
                    <input
                      type="text"
                      step="0.01"
                      name="amount"
                      value={formData.amount}
                      onChange={handleChange}
                      className="bg-gray-20 border-gray-300 h-12 py-2 px-8 outline-none  p-3 w-full border rounded-md"
                      placeholder="Enter amount"
                    />

                    <div className="absolute inset-y-0 start-0 flex items-center pointer-events-none z-20 ps-4">
                      <img src={icnaira} alt="in-naira" />
                    </div>
                    {error.amount && (
                      <p className="text-red-500 text-sm text-left">
                        {error.amount}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full">
                  <label
                    htmlFor="hs-leading-icon"
                    className="block text-left text-sm font-medium mb-1"
                  >
                    Email Address
                  </label>
                  <div className="relative mb-5">
                    <input
                      type="email"
                      name="emailAddress"
                      value={formData.emailAddress}
                      onChange={handleChange}
                      className="bg-gray-20 border-gray-300 h-12 py-2 px-8 outline-none p-3 w-full border rounded-md"
                      placeholder="Enter email address"
                    />

                    <div className="absolute inset-y-0 start-0 flex items-center pointer-events-none z-20 ps-4">
                      <svg
                        className="shrink-0 size-4 text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      >
                        <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                      </svg>
                    </div>
                    {error.emailAddress && (
                      <p className="text-red-500 text-sm text-left">
                        {error.emailAddress}
                      </p>
                    )}
                  </div>
                </div>
               
                { showInsuranceCompany &&
                  <div className="w-full">
                    <label
                      htmlFor="hs-leading-icon"
                      className="block text-left text-sm font-medium mb-1"
                    >
                      Insurance companies
                    </label>
                    <div className="relative mb-5">
                      <select
                        value={formData.insuranceCompany}
                        onChange={handleChange}
                        name="insuranceCompany"
                        id="insuranceCompany"
                        className="bg-gray-20 border-gray-300 font-light text-gray-400 h-12 py-2 px-8 outline-none p-3 w-full border rounded-md"
                      >
                        <option value="">Select an option</option>
                        {insuranceData?.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                      <div className="absolute inset-y-0 start-0 flex items-center pointer-events-none z-20 ps-4">
                        <svg
                          className="shrink-0 size-4 text-gray-400"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M12 2L4 5v6c0 5.25 3.75 10 8 10s8-4.75 8-10V5l-8-3z" />
                        </svg>
                      </div>
                      {error.insuranceCompany && (
                        <p className="text-red-500 text-sm text-left">
                          {error.insuranceCompany}
                        </p>
                      )}
                    </div>
                  </div>
                }

                <button
                  type={"submit"}
                  onClick={handleSubmit}
                  disabled={loading}
                  className="bg-[#161032] h-12 font-semibold text-lg flex items-center justify-center text-white py-3 rounded-lg hover:bg-[red] transition ease-in-out duration-300 w-full mt-20"
                >
                  {loading
                    ? "Connecting..."
                    : "Pay now"}
                </button>
              </form>
              <div className="text-center mt-12">
                <p className="text-[#001F54] text-sm">Powered by</p>
                <div className="flex items-center gap-1 mt-1">
                  <img className="w-4" src={logo} alt="cbn" />
                  <p className="text-[#001F54] text-sm font-semibold">
                    Premium<span className="text-red-500">Trust</span>Bank
                  </p>
                </div>
              </div>
              <div className="flex w-full justify-center text-center items-center gap-2 mt-12 font-medium">
                <img src={cbn} alt="cbn" />
                <p className="text-[#001F54] md:text-md text-sm">
                  Licensed by the Central Bank of Nigeria
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PayWithCard;
